(function() {
  var MAX_RETRIES = 10;
  var attempts = 0;

  function init() {
    attempts++;
    var canvas = document.querySelector('canvas');

    if (!canvas) {
      if (attempts < MAX_RETRIES) {
        setTimeout(init, 1000);
      }
      // Silent after max retries — no console spam on non-canvas pages
      return;
    }

    // Canvas found — wire fullscreen controls
    canvas.addEventListener('dblclick', function(e) {
      e.preventDefault();
      toggleFullscreen(canvas);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'f' || e.key === 'F') {
        e.preventDefault();
        toggleFullscreen(canvas);
      }
    });
  }

  function toggleFullscreen(el) {
    if (!document.fullscreenElement) {
      if (el.requestFullscreen) {
        el.requestFullscreen().catch(function() {});
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen().catch(function() {});
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }
})();
